import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import Sectiontitle from "../components/Sectiontitle";
import Layout from "../components/Layout";
import { useLanguage } from '../context/LanguageContext';

function PrivacyPolicy() {
  const { d, lang } = useLanguage();
  const location = useLocation();

  const urlParams = new URLSearchParams(location.search);
  const rawAppParam = urlParams.get('app') || '';
  const appParam = rawAppParam.toLowerCase();

  // Normalize app ID for petrotrak / petrotrack / resistorcalculator
  let selectedAppId = null;
  if (appParam === 'petrotrak' || appParam === 'petrotrack') {
    selectedAppId = 'petrotrak';
  } else if (appParam === 'resistorcalculator' || appParam === 'resistor_calculator') {
    selectedAppId = 'resistorcalculator';
  }

  const selectedAppPolicy = selectedAppId && d.privacy.appPolicies
    ? d.privacy.appPolicies.find(a => a.id === selectedAppId)
    : null;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.search]);

  const mailLink = <span>&nbsp;<a href={`mailto:${d.privacy.titles.email}`}>{d.privacy.titles.email}</a></span>;

  // RENDER MODO SOLO APP ESPECÍFICA (ej: /privacy-policy?app=petrotrak)
  if (selectedAppPolicy) {
    return (
      <Layout>
        <div className="mi-service-area mi-section mi-padding-top mi-padding-bottom">
          <div className="container">
            <Sectiontitle title={selectedAppPolicy.title || `${selectedAppPolicy.name} Privacy Policy`} />
            
            <div className="row justify-content-center">
              <div className="col-lg-10 col-12">
                <div className="mi-about-content p-4 p-md-5" style={{ background: "rgba(255,255,255,0.02)", borderRadius: "10px", border: "1px solid rgba(0, 123, 255, 0.3)" }}>
                  <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                    <span className="badge" style={{ background: "#007bff", fontSize: "0.95rem", padding: "6px 12px" }}>
                      Android Application
                    </span>
                    <span style={{ color: "#aaa", fontSize: "0.9rem" }}>
                      {selectedAppPolicy.effectiveDate || "August 2026"}
                    </span>
                  </div>

                  {selectedAppPolicy.summary && (
                    <p style={{ fontSize: "1.1rem", fontWeight: "500", color: "#ddd", marginBottom: "25px", lineHeight: "1.7" }}>
                      {selectedAppPolicy.summary}
                    </p>
                  )}

                  {selectedAppPolicy.sections && selectedAppPolicy.sections.map((sec, idx) => (
                    <div key={idx} className="mb-4">
                      <h4 style={{ color: "#007bff", fontSize: "1.2rem", marginBottom: "8px" }}>
                        {sec.heading}
                      </h4>
                      <p style={{ textAlign: "justify", lineHeight: "1.7", marginBottom: 0, color: "#ccc" }}>
                        {sec.content}
                      </p>
                    </div>
                  ))}

                  {/* Servicios de Terceros en Política Específica */}
                  <div className="mt-4 pt-3" style={{ borderTop: "1px solid rgba(255,255,255,0.1)" }}>
                    <h5 style={{ color: "#ffffff", marginBottom: "10px" }}>
                      {lang === 'es' ? 'Servicios de Terceros Utilizados' : 'Third-Party Services Used'}
                    </h5>
                    <ul style={{ paddingLeft: "20px", color: "#bbb" }}>
                      <li className="mb-2">
                        <strong>Google AdMob:</strong> {lang === 'es' ? 'Entrega de publicidad conforme a normativas de Google Play.' : 'Ad delivery complying with Google Play policies.'}{' '}
                        <a href={d.privacy.titles.admobpolicy} rel="noopener noreferrer" target="_blank">
                          {d.privacy.titles.urlLink}
                        </a>.
                      </li>
                      <li className="mb-2">
                        <strong>Firebase Analytics:</strong> {lang === 'es' ? 'Telemetría anónima y reportes de estabilidad sin datos personales.' : 'Anonymous telemetry and stability reports without personal data.'}{' '}
                        <a href={d.privacy.titles.firebasepolicy} rel="noopener noreferrer" target="_blank">
                          {d.privacy.titles.urlLink}
                        </a>.
                      </li>
                    </ul>
                  </div>

                  {/* Contacto */}
                  <div className="mt-4 pt-3" style={{ borderTop: "1px solid rgba(255,255,255,0.1)" }}>
                    <p style={{ margin: 0 }}>
                      {d.privacy.contact}{mailLink}.
                    </p>
                  </div>

                  <div className="mt-4 pt-3 text-center text-md-end">
                    <Link to="/privacy-policy" className="mi-button" style={{ background: "transparent", border: "1px solid #6c757d", color: "#aaa" }}>
                      {lang === 'es' ? 'Ver Política de Privacidad General de Desarrollador' : 'View General Developer Privacy Policy'}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }

  // RENDER MODO GENERAL DESARROLLADOR EXTENSO (sin ?app=)
  return (
    <Layout>
      <div className="mi-service-area mi-section mi-padding-top">
        <div className="container">
          <Sectiontitle title={d.privacy.titles.privacy || "Política de Privacidad General de Desarrollador"} />
          <div className="row justify-content-center">
            <div className="col-lg-10 col-12">
              <div className="mi-about-content p-4 p-md-5" style={{ background: "rgba(255,255,255,0.02)", borderRadius: "10px", border: "1px solid rgba(255,255,255,0.08)" }}>
                {d.privacy.privacydata && d.privacy.privacydata.map((element, index) => (
                  <p style={{ fontSize: "1.05rem", textAlign: "justify", marginBottom: "25px", color: "#ddd", lineHeight: "1.7" }} key={index}>
                    {element}
                  </p>
                ))}

                {/* Secciones Extensas Formales de Privacidad de Desarrollador */}
                {d.privacy.generalSections && d.privacy.generalSections.map((sec, idx) => (
                  <div key={idx} className="mb-4">
                    <h4 style={{ color: "#007bff", fontSize: "1.2rem", marginBottom: "10px" }}>
                      {sec.heading}
                    </h4>
                    <p style={{ textAlign: "justify", lineHeight: "1.7", color: "#ccc", marginBottom: 0 }}>
                      {sec.content}
                    </p>
                  </div>
                ))}

                {/* Enlaces Oficiales de Terceros */}
                <div id="external_links" className="mt-4 pt-4" style={{ borderTop: "1px solid rgba(255,255,255,0.1)" }}>
                  <h4 style={{ color: "#ffffff", marginBottom: "12px" }}>
                    {d.privacy.titles.links || "Servicios de Terceros e Infraestructura"}
                  </h4>
                  {d.privacy.linksdata && d.privacy.linksdata.map((element, index) => {
                    let link = null;
                    if (index === 1) {
                      link = <span><a href={d.privacy.titles.admobpolicy} rel="noopener noreferrer" target="_blank">&nbsp;{d.privacy.titles.urlLink}</a>.</span>;
                    } else if (index === 2) {
                      link = <span><a href={d.privacy.titles.firebasepolicy} rel="noopener noreferrer" target="_blank">&nbsp;{d.privacy.titles.urlLink}</a>.</span>;
                    }
                    return <p style={{ textAlign: "justify", marginBottom: "10px", color: "#bbb" }} key={index}>{element}{link}</p>;
                  })}
                </div>

                {/* Cambios a la Política */}
                <div id="changes" className="mt-4 pt-3" style={{ borderTop: "1px solid rgba(255,255,255,0.1)" }}>
                  <h4 style={{ color: "#ffffff", marginBottom: "10px" }}>
                    {d.privacy.titles.changes || "Actualizaciones de esta Política"}
                  </h4>
                  {d.privacy.changesdata && d.privacy.changesdata.map((element, i) => (
                    <p style={{ textAlign: "justify", marginBottom: "10px", color: "#bbb" }} key={i}>{element}</p>
                  ))}
                </div>

                {/* Contacto Oficial */}
                <div className="mt-4 pt-3" style={{ borderTop: "1px solid rgba(255,255,255,0.1)" }}>
                  <h4 style={{ color: "#ffffff", marginBottom: "10px" }}>
                    {d.privacy.titles.contact || "Contacto Legal"}
                  </h4>
                  <p style={{ textAlign: "justify", margin: 0, color: "#bbb" }}>
                    {d.privacy.contact}{mailLink}.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default PrivacyPolicy;
